<template>
  <!-- 活动卡片 -->
  <div class="m-coupon">
    <!-- 已报名 -->
    <div v-if="couponType == 1" class="coupon join-yes">
      <div class="hd">
        <div class="mask"></div>
        <div class="hbox">
          <div class="cleft">
            <div class="t1 text-line">{{ superInfo.resourceName }}</div>
            <!-- 抽奖+榜单 -->
            <div v-if="superInfo.activityCategory == 3" class="t3">
              buff券
              <span class="c-blue">前{{ superInfo.rankQuota }}名</span>
              必得,再抽<span class="c-blue">{{ superInfo.ticketQuota }}</span
              >人
            </div>
          </div>

          <!-- 抽奖+榜单,抽奖,榜单 -->
          <div class="cright">
            <div class="t3">
              共<span>{{ getQuota }}</span
              >个名额
            </div>
            <div v-if="superInfo.activityCategory != 3" class="t2">
              {{ superInfo.activitySignupCount }}人报名
            </div>
          </div>
        </div>
      </div>

      <div class="bd">
        <div v-if="superInfo.activityCategory !== 2" class="txt">
          <div class="t1">实时中奖预测</div>
          <div class="t2">中奖率＝奖品数*我的中奖份额/总中奖份额</div>
        </div>
        <div v-if="superInfo.activityCategory !== 2" class="num-box">
          <span class="num-box-line"></span>
          <div class="nleft">
            <div class="t2">我的中奖份额</div>
            <div class="t1">
              {{ superInfo.userInfo.myParticipatedTicketCount }}
            </div>
          </div>
          <div class="nright">
            <div class="t2">总中奖份额</div>
            <div class="t1">
              {{ superInfo.allLotteryTicketCount }}
            </div>
          </div>
        </div>

        <!-- 排名模块 仅榜单玩法可见 -->
        <v-mod-ranking
          v-if="
            userInfo.uuid &&
            (superInfo.activityCategory === 2 ||
              superInfo.activityCategory === 3)
          "
          :superInfo="superInfo"
          :rankingList="rankingList"
          :rankNumStr="rankNumStr"
          :rankStats="superInfo.activityCategory === 3 ? 'end' : ''"
        />
        <div v-if="userInfo.uuid" class="line"></div>
      </div>

      <div class="jy-ft">
        <div class="tit">中奖攻略</div>
        <div v-if="actInfo.img3" class="item">
          <van-image
            class="s"
            :src="actInfo.img3"
            fit="cover"
            @click="handleJump(actInfo.url3)"
          />
        </div>
        <div v-if="actInfo.img4" class="item">
          <van-image
            class="s"
            :src="actInfo.img4"
            fit="cover"
            @click="handleJump(actInfo.url4)"
          />
        </div>

        <div class="num" @click="handleToast('完成邀请任务可以获得更多buff券')">
          我的buff券余额 {{ superInfo.userInfo.myRemainingTicketCount }} 张
        </div>
      </div>
    </div>

    <!-- 未报名 -->
    <div v-if="couponType == 2" class="coupon join-not">
      <div class="hd">
        <div class="mask"></div>
        <div class="hbox">
          <div class="cleft">
            <div class="t1 text-line">
              {{ superInfo.resourceName }}
            </div>
          </div>

          <div class="cright">
            <div class="t3">
              共<span>{{ getQuota }}</span
              >个名额
            </div>
            <div class="t2">{{ superInfo.activitySignupCount }}人报名</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 即将报名 -->
    <div v-if="couponType == 3" class="coupon join-start">
      <div class="hd">
        <div class="mask"></div>
        <div class="hbox">
          <div class="cleft">
            <div class="t1 text-line">{{ superInfo.resourceName }}</div>
          </div>

          <div class="cright">
            <div class="t3">
              共<span>{{ getQuota }}</span
              >个名额
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 开奖中 -->
    <div v-if="couponType == 4" class="coupon join-open">
      <div class="hd">
        <div class="mask"></div>
        <div class="hbox">
          <div class="cleft">
            <div class="t1 text-line">
              {{ superInfo.resourceName }}
            </div>
            <div v-if="superInfo.activityCategory !== 2" class="t2">
              可能有<span>{{ sqNum }}</span
              >张捡漏
            </div>
          </div>

          <div class="cright">
            <div class="t1">
              <div class="t">已开奖登记中</div>
            </div>
            <div class="t2">{{ superInfo.activitySignupCount }}人报名</div>
          </div>
        </div>
      </div>
      <div class="bd" v-if="userInfo.uuid || giftList.length > 0">
        <div v-if="superInfo.activityCategory !== 2">
          <v-mod-coupon-list :list="giftList"></v-mod-coupon-list>
          <div class="tips">如果有用户未在截止之前完成登记的，则开启候补</div>
          <div v-if="userInfo.uuid" class="line"></div>
        </div>
        <!-- 排名模块 仅榜单玩法可见 -->
        <v-mod-ranking
          v-if="
            userInfo.uuid &&
            (superInfo.activityCategory === 2 ||
              superInfo.activityCategory === 3)
          "
          :superInfo="superInfo"
          :couponType="couponType"
          :rankStats="'end'"
          :rankingList="rankingList"
          :rankNumStr="rankNumStr"
        />
      </div>
    </div>

    <!-- 已结束 -->
    <div v-if="couponType == 5" class="coupon join-end">
      <div class="hd">
        <div class="mask"></div>
        <div class="hbox">
          <div class="cleft">
            <div class="t1 text-line">{{ superInfo.resourceName }}</div>
            <div class="t2">
              本轮奖品:
              <span>{{ getQuota }}</span>
            </div>
          </div>

          <div class="cright">
            <div class="t1">已发放奖品</div>
            <div class="t2">{{ superInfo.activitySignupCount }}人报名</div>
          </div>
        </div>
      </div>
      <div class="bd" v-if="userInfo.uuid || giftList.length > 0">
        <v-mod-coupon-list :list="giftList" :type="'end'"></v-mod-coupon-list>

        <span v-if="userInfo.uuid" class="line"></span>
        <!-- 排名模块 仅榜单玩法可见 -->
        <v-mod-ranking
          v-if="
            userInfo.uuid &&
            (superInfo.activityCategory === 2 ||
              superInfo.activityCategory === 3)
          "
          :superInfo="superInfo"
          :couponType="couponType"
          :rankStats="'end'"
          :rankingList="rankingList"
          :rankNumStr="rankNumStr"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Toast, Image as VanImage } from "vant";
import { jumpPage, getQuery } from "@utils/url";
import service from "@utils/service.js";
import VModCouponList from "@components/v-mod-coupon-list.vue";
import { statClick } from "@utils/h5-report";
import VModRanking from "@components/v-mod-ranking.vue";

export default {
  name: "MCard",

  data() {
    return {
      giftList: [], // 获取中奖列表
      sqNum: 0, //可能捡漏数量
      bgColor: this.superInfo.backgroundColor || "",
      superId: getQuery("superId") || "",
      rankingList: [],
      rankNumStr: 0,
    };
  },
  components: { VanImage, VModCouponList, VModRanking },

  props: {
    superInfo: {
      type: Object,
      default: () => {},
    },
    actInfo: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState(["userInfo", "identity"]),
    getQuota() {
      if (this.superInfo.activityCategory == 3) {
        return this.superInfo.totalQuota;
      } else if (this.superInfo.activityCategory == 2) {
        return this.superInfo.rankQuota;
      }
      return this.superInfo.ticketQuota;
    },
    // 用户状态
    couponType() {
      const {
        activityCurrentStatus,
        userInfo: { userSignupStatus },
      } = this.superInfo;

      // 报名中 已报名
      if (userSignupStatus == 1 && activityCurrentStatus == 1) {
        this.getRankList(); // 排名
        return 1;
      }
      // 报名中 未报名
      if (userSignupStatus == 0 && activityCurrentStatus == 1) {
        return 2;
      }
      // 即将报名
      if (activityCurrentStatus == 0) {
        return 3;
      }
      // 开奖中
      if (activityCurrentStatus == 2 || activityCurrentStatus == 3) {
        this.getGiftList(); // 中奖列表
        this.getRankList(); // 排名
        return 4;
      }
      // 已结束
      if (activityCurrentStatus == 4) {
        this.getGiftList(); // 中奖列表
        this.getRankList(); // 排名
        return 5;
      }
      // 默认情况
      return -1;
    },

    // 背景渐变参数
    getGradientStyle() {
      // 将 HEX 颜色转换为 RGBA
      const hexToRgba = (hex, opacity) => {
        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);
        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
      };

      // 生成渐变背景
      return {
        backgroundColor: hexToRgba(this.superInfo.backgroundColor, 0.1),
      };
    },
  },
  mounted() {},

  methods: {
    // 跳转
    handleJump(url) {
      // 数据上报
      statClick(
        {
          actid: this.superId,
          identity: this.identity,
          url,
        },
        {
          cont: "点击活动任务",
          mod: "mgcard_help",
        },
      );
      jumpPage(url);
    },

    handleToast(msg) {
      Toast(msg);
    },

    // 获取中奖列表
    async getGiftList() {
      let params = {
        activityId: this.superId,
        limit: 1000,
      };
      const res = await service.getSuperList(params);
      if (res.errno === "0" && res.data) {
        this.giftList = res.data.list || [];
        this.sqNum = res.data.possibleSpareQuantity;
      }
    },

    // 获取榜单列表
    async getRankList() {
      let params = {
        activityId: this.superId,
      };
      const res = await service.getRankList(params);
      if (res.errno === "0") {
        this.rankNumStr = res.data.rankNumStr;
        this.rankingList = res.data.list;
      }
    },
  },
};
</script>

<style lang="less">
.m-coupon {
  position: relative;
  z-index: 5;
  .coupon {
    text-align: center;
    box-sizing: border-box;
    .hd {
      position: relative;
      z-index: 5;
      padding-bottom: 18px;
      // background: #fff;
      // border-radius: 0 0 10px 10px;

      .mask {
        position: absolute;
        bottom: -37.5px;
        left: 4px;
        z-index: 5;
        width: 320px;
        height: 37.5px;
        background: linear-gradient(180deg, #869da6 0%, rgba(0, 0, 0, 0) 100%);
        opacity: 0.05;
      }
      .hbox {
        width: 305px;
        height: 67px;
        margin: 0 auto;
        overflow: hidden;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-image: url("../assets/image/bg-coupon02.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: left bottom;
      }
      .arr {
        position: absolute;
        left: 147px;
        z-index: 5;
        width: 15px;
        height: 15px;
        background: #fff;
        border-radius: 50%;
      }
      .arr-up {
        top: -9px;
      }
      .arr-down {
        bottom: -9px;
      }
      .cleft {
        width: 200px;
        padding: 10px 10px 10px 18px;
        text-align: left;
        box-sizing: border-box;
        .t1 {
          font-size: 19px;
          color: #02001c;
          font-weight: 500;
        }
        .t2 {
          font-size: 13px;
          color: rgba(2, 0, 28, 0.8);
          span {
            font-size: 15px;
            font-weight: 600;
          }
          .c-blue {
            font-size: 13px;
            color: #3581ff;
          }
        }
        .t3 {
          font-size: 12px;
          color: #103a64;
          .c-blue {
            color: #3581ff;
          }
        }
      }
      .cright {
        flex: 1;
        text-align: right;
        padding: 15px 15px 15px 0;
        box-sizing: border-box;
        .t1 {
          display: flex;
          align-items: center;
          justify-content: right;
          margin-bottom: 5px;
          font-weight: 500;
          font-size: 14px;
          color: rgba(2, 0, 28, 0.8);
        }
        .t2 {
          font-size: 11px;
          color: rgba(0, 0, 0, 0.4);
        }
        .t3 {
          font-weight: 400;
          font-size: 12px;
          color: rgba(0, 0, 0, 0.6);
          span {
            font-size: 15px;
            font-weight: 600;
          }
        }
      }
    }
    .bd {
      position: relative;
      width: 320px;
      margin: 0 auto;
      padding: 25px 0 5px;
      background: linear-gradient(180deg, #ffffff 0%, #ffffff 100%);

      .line {
        display: block;
        width: 290px;
        height: 11px;
        margin: 0 auto 20px;
        text-indent: -9999px;
        background-image: url("../assets/image/icon-line.png");
        background-repeat: no-repeat;
        background-size: 100% auto;
        background-position: center top;
      }

      .tips {
        text-align: center;
        font-weight: 400;
        font-size: 10px;
        color: rgba(0, 0, 0, 0.3);
        margin-bottom: 15px;
      }
    }
    .ft {
      text-align: left;
      .num {
        text-align: center;
      }
      .tips {
        padding-top: 5px;
        text-align: center;
        font-weight: 400;
        font-size: 10px;
        color: rgba(0, 0, 0, 0.3);
      }
    }
  }
  .join-open,
  .join-end {
    .hd {
      padding-bottom: 10px;
      .hbox {
        height: 75px;
        background-image: url("../assets/image/bg-coupon01.png");
        background-repeat: no-repeat;
        background-size: 100% auto;
        background-position: left bottom;
      }
      .cleft {
        width: 190px;
        .t1 {
          margin-bottom: 2px;
        }
      }
    }
  }
  .join-yes {
    .bd {
      position: relative;
      width: 320px;
      margin: 0 auto;
      padding: 30px 0 11px;
      // background-image: url("../assets/image/bg-time.png");
      // background-repeat: no-repeat;
      // background-size: 100% auto;
      // background-position: center top;
      background: #fff;
      box-sizing: border-box;
      .txt {
        margin-bottom: 20px;
        padding: 0 15px;
        .t1 {
          width: 130.5px;
          height: 25px;
          margin: 0 auto 5px;
          text-indent: -9999px;
          background-image: url("../assets/image/icon-tit01.png");
          background-repeat: no-repeat;
          background-size: 100% auto;
          background-position: center top;
          box-sizing: border-box;
        }
        .t2 {
          font-weight: 400;
          font-size: 13px;
          color: rgba(0, 0, 0, 0.6);
        }
      }
      .line {
        width: 290px;
        height: 11px;
        margin: 10px auto 0;
        text-indent: -9999px;
        background-image: url("../assets/image/icon-line.png");
        background-repeat: no-repeat;
        background-size: 100% auto;
        background-position: center top;
      }
      .num-box {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 290px;
        height: 72px;
        margin: 0 auto;
        margin-bottom: 20px;
        // padding: 0 15px;
        background: rgba(244, 245, 245, 0.8);
        border-radius: 10px;
        .num-box-line {
          position: absolute;
          top: 20px;
          left: 50%;
          width: 1px;
          height: 31px;
          border-right: 2px solid #979797;
          opacity: 0.19;
        }
        .t1 {
          font-family: ArialNarrow;
          font-weight: 600;
          font-size: 21px;
          color: #00223b;
        }
        .t2 {
          margin-bottom: 5px;
          font-weight: 600;
          font-size: 11px;
          color: rgba(0, 34, 59, 0.41);
        }
        .nleft {
          width: 50%;
        }
        .nright {
          width: 50%;
        }
      }
    }

    .jy-ft {
      width: 320px;
      margin: 0 auto;
      background: #fff;
      .tit {
        width: 91px;
        height: 30px;
        margin: 0 auto 14px;
        text-indent: -9999px;
        background-image: url("../assets/image/icon-tit02.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center top;
        box-sizing: border-box;
      }
      .item {
        width: 290px;
        margin: 0 auto 15px;
      }
      .num {
        padding-bottom: 5px;
        font-weight: 400;
        font-size: 13px;
        color: rgba(0, 0, 0, 0.6);
      }
    }
  }
}
</style>
